import Actions from '.';
import { get } from '../../../utils/api';
import { API_ERROR_MESSAGE, DEFAULT_RECORD_LIMIT } from '../../../constants';


const searchProducts = () => (async (dispatch, getState) => {
    const { productSearch: { search } } = getState();
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`products/search/title?searchText=${search}&limit=${DEFAULT_RECORD_LIMIT}`);
        if (data.statusCode === 200) {            
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: data.response.products || [],
                nextPageToken: (data.response || {}).nextPageToken,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.statusCode === 404 ? '' : (data.message || API_ERROR_MESSAGE),
                list: [],
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            list: [],
            nextPageToken: null,
        }));
    }
});

const loadMoreProducts = () => (async (dispatch, getState) => {
    const { productSearch: { nextPageToken, list } } = getState();
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`products/search/title?nextPageToken=${nextPageToken}`);
        if (data.statusCode === 200 && data.response) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: [...list, ...data.response.products],
                nextPageToken: (data.response || {}).nextPageToken,
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                nextPageToken: null,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            nextPageToken: null,
        }));
    }
});


export default {
    searchProducts,
    loadMoreProducts,
}